import React, { useEffect, useState } from "react";
import { TablePagination, Modal, Box, FormControl } from "@mui/material";
import TableHeader from "../table/TableHeader";
import JourneyTableRow from "./JourneyTableRow";
import MainTableBody from "../table/MainTableBody";
import CustomTable from "../table/CustomTable";
import { LoadingTableSkeleton } from "../../utils/common";
import NoDataTable from "../table/NoDataTable";
import FilterDropdown from "../filter/FilterDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmBox from "../ConfirmBox";
import useAuthFetch from "../../hooks/useAuthFetch";
import { CustomizeTextField, style } from "../templates/TemplateTable";
import { CloseOutlined, CopyAllOutlined } from "@mui/icons-material";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import ToggleSwitch from "../ToggleSwitch";


export const ResetJourneyLimitModal = ({ refetch, setOpenErr, setErrMsg }) => {
  const customFetch = useAuthFetch();
  const [applicationNo, setApplicationNo] = React.useState();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  async function resetLimit({ applicationNo }) {
    const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/application/resetLimit`);

    const method = "POST"

    const bodyContent = {
      applicationNo: applicationNo
    }
    const { response, status, message } = await customFetch(
      url,
      method,
      bodyContent
    );

    if (status === 200) {
      toast.success(`Journey limit for ${applicationNo} reset successful!`, {
        position: "bottom-right",
      });
      setApplicationNo("");
    } else {
      setOpenErr(true);
      setErrMsg(
        message
          ? message
          : "Something went wrong while resetting journey limit!"
      );
    }
    handleClose();
  }

  return (
    <div className="">
      <button
        onClick={handleOpen}
        className=" border focus:border-blue-600 flex items-center text-white border-[#E0E0E0] bg-blue-600 ml-2 rounded py-1.5 px-3"
      >
        Reset Journey Limit
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="rounded-xl relative">
          <button className="absolute top-2 right-3" onClick={handleClose}>
            <CloseOutlined className="w-5 h-5  text-gray-450 hover:text-black" />
          </button>
          <p className="text-2xl mb-0 font-extrabold text-center text-gray-850">
            Reset Application Journey Limit
          </p>
          <div className="mt-9">
            <FormControl variant="outlined" className="w-full">
              <CustomizeTextField
                id="outlined-adornment-weight"
                aria-describedby="outlined-weight-helper-text"
                inputProps={{
                  "aria-label": "weight",
                }}
                placeholder="Enter Application No"
                className="bg-[#F3F4F8] text-black w-full  rounded-lg"
                value={applicationNo}
                onChange={(e) => {
                  setApplicationNo(e.target.value);
                }}
              />
            </FormControl>
          </div>

          <div className="mt-4 flex items-center justify-center">
            <button
              className="bg-purple-300 py-3 w-full text-white text-base font-bold rounded-lg"
              onClick={async () => {
                await resetLimit({
                  applicationNo: applicationNo,
                });
              }}
            >
              Reset
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export const ResetJourneyStatusModal = ({ refetch, setOpenErr, setErrMsg }) => {
  const customFetch = useAuthFetch();

  const [applicationNo, setApplicationNo] = useState("");
  const [meTicketNo, setMeTicketNo] = useState("");
  const [validationErr, setValidationErr] = useState({
    applicationNo: false,
    meTicketNo: false,
  });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setApplicationNo("");
    setMeTicketNo("");
    setValidationErr({
      applicationNo: false,
      meTicketNo: false,
    });
    setOpen(false);
  };

  const validateFields = () => {
    const errors = {
      applicationNo: !applicationNo.trim(),
      meTicketNo: !meTicketNo.trim(),
    };

    setValidationErr(errors);
    return !Object.values(errors).some((err) => err);
  };

  async function resetLimit({ applicationNo, meTicketNo }) {
    if (!validateFields()) return;

    try {
      const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/application/resetJourney`);
      const method = "POST";

      const bodyContent = { applicationNo, meTicketNo };

      const { response, status, message } = await customFetch(
        url,
        method,
        bodyContent
      );

      if (status === 200) {
        toast.success(`Application Status for ${applicationNo} reset successful!`, {
          position: "bottom-right",
        });
        refetch && refetch();
        handleClose();
      } else {
        setOpenErr(true);
        setErrMsg(
          message || "Something went wrong while resetting application status!"
        );
      }
    } catch (e) {
      setOpenErr(true);
      setErrMsg("Something went wrong while resetting application status!");
    }
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: 6,
  };

  return (
    <div>
      <button
        onClick={handleOpen}
        className="border focus:border-blue-600 flex items-center text-white border-[#E0E0E0] bg-blue-600 ml-2 rounded py-1.5 px-3"
      >
        Reset Application Status
      </button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="reset-status-modal-title"
        aria-describedby="reset-status-modal-description"
      >
        <Box sx={style} className="rounded-xl relative">
          <button className="absolute top-2 right-3" onClick={handleClose}>
            <CloseOutlined className="w-5 h-5 text-gray-450 hover:text-black" />
          </button>

          <p className="text-2xl mb-0 font-extrabold text-center text-gray-850">
            Reset Application Status
          </p>

          {[
            {
              label: "Enter Application No",
              value: applicationNo,
              setter: setApplicationNo,
              error: validationErr.applicationNo,
              errorMsg: "Application No is required.",
            },
            {
              label: "Enter ME Ticket No",
              value: meTicketNo,
              setter: setMeTicketNo,
              error: validationErr.meTicketNo,
              errorMsg: "ME Ticket No is required.",
            },
          ].map(({ label, value, setter, error, errorMsg }, index) => (
            <div key={index} className="mt-6">
              <FormControl variant="outlined" className="w-full">
                <CustomizeTextField
                  placeholder={label}
                  className="bg-[#F3F4F8] text-black w-full rounded-lg"
                  value={value}
                  onChange={(e) => setter(e.target.value)}
                />
              </FormControl>
              {error && <p className="text-red-500 text-sm mt-1">{errorMsg}</p>}
            </div>
          ))}

          <div className="mt-7 flex items-center justify-center">
            <button
              className={`${!applicationNo.trim() || !meTicketNo.trim()
                ? "bg-purple-200 cursor-not-allowed"
                : "bg-purple-300"
                } py-3 w-full text-white text-base font-bold rounded-lg`}
              disabled={!applicationNo.trim() || !meTicketNo.trim()}
              onClick={() =>
                resetLimit({
                  applicationNo: applicationNo.trim(),
                  meTicketNo: meTicketNo.trim(),
                })
              }
            >
              Reset
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};


export const JourneyLinkModal = ({ setOpenErr, setErrMsg }) => {
  const customFetch = useAuthFetch();
  const [applicationNo, setApplicationNo] = React.useState("");
  const [dob, setDob] = React.useState();
  const [link, setLink] = React.useState();
  const [validationErr, setValidationErr] = React.useState({
    applicationNo: false,
    dob: false,
  });

  const validateFields = () => {
    const trimmedAppNo = applicationNo.trim();
    const errors = {
      applicationNo: !/^[A-Za-z0-9]+$/.test(trimmedAppNo),
      dob: !dob,
    };

    setValidationErr(errors);
    return !Object.values(errors).some((err) => err);
  };



  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setLink(null)
    setDob(null)
    setApplicationNo(null)
    setValidationErr({ applicationNo: false, dob: false });
    setOpen(false);

  }

  async function generateLink({ applicationNo, dob }) {
    if (!validateFields()) return;
    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/journey/generateLink`
    );

    const method = "POST"
    const bodyContent = {
      applicationNo: applicationNo,
      dob: dob
    }
    const { response, status, message } = await customFetch(
      url,
      method,
      bodyContent
    );

    if (status === 200) {
      toast.success(`Journey link for ${applicationNo} generated!`, {
        position: "bottom-right",
      });
      setLink(response?.journeyLink)
      setApplicationNo("");
      setDob("");
    } else {
      setOpenErr(true);
      setErrMsg(
        message
          ? message
          : "Something went wrong while geenrating journey link!"
      );
    }
  }

  return (
    <div className="">
      <button
        onClick={handleOpen}
        className=" border focus:border-blue-600 flex items-center text-white border-[#E0E0E0] bg-blue-600 ml-2 rounded py-1.5 px-3"
      >
        Generate Journey Link
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="rounded-xl relative">
          <button className="absolute top-2 right-3" onClick={handleClose}>
            <CloseOutlined className="w-5 h-5  text-gray-450 hover:text-black" />
          </button>
          <p className="text-2xl mb-0 font-extrabold text-center text-gray-850">
            Generate Journey Link
          </p>
          <div className="mt-9">
            <FormControl variant="outlined" className="w-full">
              <CustomizeTextField
                id="outlined-adornment-weight"
                aria-describedby="outlined-weight-helper-text"
                inputProps={{
                  "aria-label": "weight",
                }}
                placeholder="Enter Application No"
                className="bg-[#F3F4F8] text-black w-full  rounded-lg"
                value={applicationNo}
                onChange={(e) => {
                  setApplicationNo(e.target.value);
                }}
              />
              {validationErr.applicationNo && (
                <p className="text-red-500 text-sm mt-1">
                  Application number must be alphanumeric and not empty.
                </p>
              )}


              <input
                type="date"
                value={dob}
                max={null}
                onChange={(e) =>
                  setDob(e.target.value)
                }
                className="w-full mt-4 bg-[#F3F4F8] rounded p-3.5  focus:outline-none focus:ring-1 focus:ring-primary-500"
              />
              {validationErr.dob && (
                <p className="text-red-500 text-sm mt-1">Date of birth is required.</p>
              )}
            </FormControl>
          </div>

          <div className="mt-4 flex items-center justify-center">
            <button
              className="bg-purple-300 py-3 w-full text-white text-base font-bold rounded-lg"
              onClick={async () => {
                await generateLink({
                  applicationNo: applicationNo,
                  dob: dob,
                });
              }}
            >
              Generate Link
            </button>
          </div>

          {link && (
            <div className="mt-4 ">
              <div className="bg-gray-50 rounded-lg flex items-center gap-2 break-all">
                <p className="text-sm text-gray-700 flex-1 p-2">{link}</p>
                <button
                  className="p-2 hover:bg-gray-200 rounded-full transition-colors"
                  onClick={() => {
                    navigator.clipboard.writeText(link);
                    toast.success("Journey link copied to clipboard!", {
                      position: "bottom-right",
                    });
                  }}
                >
                  <CopyAllOutlined className="text-gray-600" />
                </button>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default function JourneyTable({
  reqState,
  object,
  setObject,
  handleFetch,
  handleFetchWithPage,
  isExporting
}) {
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [page, setPage] = React.useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [openErr, setOpenErr] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  const userRole = JSON.parse(Cookies.get("userDets") || "{}").role;

  useEffect(() => {
    if (reqState.response?.pageInfo) {
      setRowsPerPage(reqState.response.pageInfo.perPage);
      setPage(reqState.response.pageInfo.currentPage - 1); // Convert to 0-indexed for MUI
    }
  }, [reqState?.response]);

  const updateQueryParams = (updatedParams) => {
    const searchParams = new URLSearchParams(location.search);

    // Update or remove query parameters based on `updatedParams`
    Object.keys(updatedParams).forEach((key) => {
      if (updatedParams[key] !== undefined && updatedParams[key] !== null) {
        searchParams.set(key, updatedParams[key]);
      } else {
        searchParams.delete(key);
      }
    });

    // Navigate with updated query parameters
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const { isLoading, response } = reqState;

  const refetch = () => {
    // const q = { ...query, page: 1 };
    // if (!q.query) delete q.query;
    // navigate({
    //   pathname: window.location.pathname, // current path
    //   search: `?${new URLSearchParams(q).toString()}`, // query string
    // }, { replace: true });
    handleFetch();
  };

  const columns = [
    "JourneyId",
    "ApplicationNo",
    "Agent Code (fsc_um_code)",
    "Journey Initiate Date",
    "Duration",
    "Status",
    "Remark",
    "",
  ];

  useEffect(() => {
    if (response?.pageInfo) {
      setRowsPerPage(response?.pageInfo.perPage);
      setPage(response?.pageInfo?.currentPage - 1);
    }
  }, [response]);

  const handleChangePage = (event, newPage) => {
    const updatedPage = newPage + 1; // Material-UI uses 0-based indexing
    updateQueryParams({ page: updatedPage });
    handleFetchWithPage(updatedPage); // Trigger fetch for the new page
  };

  const handleRowsPerPageChange = (event) => {
    const newPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to the first page
    updateQueryParams({ perPage: newPerPage, page: 1 });
  };

  return (
    <>
      <div
        className="py-1 px-4"
        style={{
          height: `calc(100vh - 100px)`,
        }}
      >
        <div className="flex flex-row mb-4 items-center justify-between">
          <p className="text-xl mb-0 font-extrabold">
            Journeys ({response?.pageInfo.total})
          </p>
          <div className="flex flex-row">
            {(userRole === "ADMIN") && (
              <ToggleSwitch />
            )}
            <FilterDropdown object={object} setObject={setObject} handleFetch={handleFetch} isExporting={isExporting} />
            <button
              onClick={() => handleFetch()}
              className="border focus:border-blue-600 flex items-center border-[#E0E0E0] ml-2 rounded py-1.5 px-3"
            >
              Refresh Data
            </button>
            {(userRole === "ADMIN" || userRole === "USER" || userRole === "GCUSER" || userRole === "ASSESSOR") && (
              <ResetJourneyLimitModal
                setErrMsg={setErrMsg}
                setOpenErr={setOpenErr}
              />
            )}
            {(userRole === "ADMIN" || userRole === "ASSESSOR") && (
              <ResetJourneyStatusModal
                setErrMsg={setErrMsg}
                setOpenErr={setOpenErr}
              />
            )}

            {(userRole === "ADMIN" || userRole === "USER" || userRole === "GCUSER" || userRole === "ASSESSOR") && (
              <JourneyLinkModal setErrMsg={setErrMsg} setOpenErr={setOpenErr} />
            )}
          </div>
        </div>

        {!response?.data && !isLoading ? (
          <NoDataTable
            columns={columns}
            recordingKeyClassName={true}
            message={"Server Error, Please try again later."}
          />
        ) : response?.data?.length === 0 && !isLoading ? (
          <NoDataTable
            columns={columns}
            recordingKeyClassName={true}
            message={"No journeys available to show"}
          />
        ) : (
          <CustomTable>
            <TableHeader columns={columns} />
            <MainTableBody isLoading={isLoading}>
              {response?.data?.length === 0
                ? [1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                  <LoadingTableSkeleton key={i} index={i} />
                ))
                : response?.data?.map((row, i) => (
                  <JourneyTableRow key={i} row={row} refetch={refetch} />
                ))}
            </MainTableBody>

            {response?.pageInfo && (
              <TablePagination
                className="sticky bottom-0 bg-white"
                rowsPerPageOptions={[20]}
                count={response?.pageInfo.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onRowsPerPageChange={handleRowsPerPageChange}
                onPageChange={handleChangePage}
              />
            )}
          </CustomTable>
        )}
      </div>
      <ConfirmBox
        open={openErr}
        setOpen={setOpenErr}
        buttonText={"Close"}
        text={errMsg}
      />
    </>
  );
}
